export default __webpack_public_path__ + "static/media/Gilroy-UltraLight.d23a0edf.woff";